/* A persistent, elegant SVG firework burst so the hero ALWAYS shows a recognisable
 * firework — independent of the timed canvas animation. Radiating rays fade from a
 * bright core to transparent tips, with small spark dots. */
export default function StaticFirework({ cx = 70, cy = 32, size = 340, rays = 30, gradId = "cf-fw-gold", stops, opacity = 0.9, seed = 1 }) {
  const c = size / 2;
  const rnd = (i) => {
    const x = Math.sin((i + 1) * 12.9898 * seed) * 43758.5453;
    return x - Math.floor(x);
  };
  const defaultStops = [
    { o: "0%", c: "#FFF6DC", a: 1 },
    { o: "35%", c: "#F5C563", a: 0.9 },
    { o: "70%", c: "#E8B54B", a: 0.35 },
    { o: "100%", c: "#E8B54B", a: 0 },
  ];
  const s = stops || defaultStops;

  return (
    <div className="absolute pointer-events-none" style={{ left: `${cx}%`, top: `${cy}%`, transform: "translate(-50%, -50%)", opacity }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <defs>
          <radialGradient id={gradId} cx="50%" cy="50%" r="50%">
            {s.map((st, i) => (
              <stop key={i} offset={st.o} stopColor={st.c} stopOpacity={st.a} />
            ))}
          </radialGradient>
          <radialGradient id={`${gradId}-core`} cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FFF6DC" stopOpacity="0.9" />
            <stop offset="60%" stopColor="#F5C563" stopOpacity="0.25" />
            <stop offset="100%" stopColor="#F5C563" stopOpacity="0" />
          </radialGradient>
        </defs>
        <circle cx={c} cy={c} r={size * 0.22} fill={`url(#${gradId}-core)`} />
        {Array.from({ length: rays }).map((_, i) => {
          const ang = (Math.PI * 2 * i) / rays;
          const r0 = size * 0.05;
          const r1 = size * (0.34 + rnd(i) * 0.14);
          const x1 = c + Math.cos(ang) * r0;
          const y1 = c + Math.sin(ang) * r0;
          const x2 = c + Math.cos(ang) * r1;
          const y2 = c + Math.sin(ang) * r1;
          return (
            <g key={i}>
              <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={`url(#${gradId})`} strokeWidth={1.6} strokeLinecap="round" />
              <circle cx={x2} cy={y2} r={1.5 + rnd(i + 7) * 1.2} fill="#FFE7B0" opacity={0.85} />
            </g>
          );
        })}
      </svg>
    </div>
  );
}
